module.exports = __webpack_public_path__ + "static/images/components/Nation/images/flag-cn-ussr.6cc3308e.png";


//////////////////
// WEBPACK FOOTER
// ./components/Nation/images/flag-cn-ussr.png
// module id = 2634
// module chunks = 11